import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 2rem 0;

  & label {
    cursor: pointer;
  }
`

export const Container = styled.label`
  position: relative;
  display: inline-block;
  min-width: 3.125rem;
  width: 3.125rem;
  height: 1.5rem;
  order: -1;

  input {
    opacity: 0;
    overflow: hidden;
    filter: alpha(opacity=0);
  }

  input:checked + span {
    background-color: rgba(var(--theme-primary));
  }

  input:checked + span:before {
    transform: translateX(1.625rem);
  }

  input:focus + span {
    outline: none;
    box-shadow: 0 0 0 3px rgba(var(--theme-primary), 0.32);
  }

  input:not(:checked):focus + span {
    outline: none;
    box-shadow:
      0 0 0 1px rgba(var(--theme-surface-snow)),
      0 0 0 3px rgba(var(--theme-black), 0.32);
  }

  input:focus + span,
  input:checked:focus + span {
    outline: none;
    box-shadow:
      0 0 0 1px rgba(var(--theme-surface-snow)),
      0 0 0 3px rgba(var(--theme-primary), 0.32);
  }
`

export const Slider = styled.span`
  position: absolute;
  right: 0;
  top: 0;
  left: 0;
  bottom: 0;
  cursor: pointer;
  background-color: rgba(var(--theme-black), 0.32);
  transition: var(--theme-transition);
  border-radius: 34px;

  &:before {
    content: '';
    position: absolute;
    bottom: 0.125rem;
    left: 0.125rem;
    width: 1.25rem;
    height: 1.25rem;
    background-color: rgba(var(--theme-surface-snow));
    border-radius: 50%;
    transition: var(--theme-transition);
  }
`
